export default __webpack_public_path__ + "static/media/Hood of Deadly Guile.54d4654a.jpg";